export { default } from './TitleHeader';



// WEBPACK FOOTER //
// ./src/components/TitleHeader/index.js